"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genXAPIValidData = void 0;
const genXAPIValidData = ({ elementType, verb, data, }) => {
    const xAPIData = Object.assign({ verb, elementType }, data);
    return { xAPIData };
};
exports.genXAPIValidData = genXAPIValidData;
